export const SET_PROCESS_STARTED = 'LAUNCHPROGRESSBAR_TEXTS_SET_PROCESS_STARTED'
export const SET_AUTHORIZING = 'LAUNCHPROGRESSBAR_TEXTS_SET_AUTHORIZING'
export const SET_AUTHORIZATION_FAILED = 'LAUNCHPROGRESSBAR_TEXTS_SET_AUTHORIZATION_FAILED'
export const SET_REFRESH = 'LAUNCHPROGRESSBAR_TEXTS_SET_REFRESH'
export const SET_STARTING = 'LAUNCHPROGRESSBAR_TEXTS_SET_STARTING'
export const SET_TEXTS = 'LAUNCHPROGRESSBAR_TEXTS_SET_TEXTS'



// WEBPACK FOOTER //
// ./src/features/LaunchProgressBar/data/texts/constants.js